import { API_V1 } from 'API/APIs/APIv1';
import _ from 'lodash';
import Logger from 'logger';

export const getLinkedinProjectById = async (projectId: string) => {
  try {
    const response = await API_V1.get(`/linkedinproject/${projectId}`);

    return response.data;
  } catch (e) {
    Logger.trace('Error while fetching a single LinkedIn project!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e) };
  }
};

export const createLinkedinProject = async (name: string, contacts: string[]) => {
  try {
    const response = await API_V1.post('/linkedinproject', {
      name,
      contacts,
    });

    return response.data;
  } catch (e) {
    Logger.trace('Error while creating a LinkedIn project!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e) };
  }
};

export const analyzeLinkedinContacts = async (
  linkedinProjectId: string,
  liAtCookie: string,
  sessionCookie: string,
  seatCookie?: string
) => {
  try {
    const response = await API_V1.post('/linkedinproject/analyzeLinkedinContacts', {
      linkedinProjectId,
      liAtCookie: liAtCookie ? liAtCookie : undefined,
      sessionCookie: sessionCookie ? sessionCookie : undefined,
      seatCookie: seatCookie ? seatCookie : undefined,
    });

    return response.data;
  } catch (e) {
    Logger.trace('Error while analyzing LinkedIn contacts!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e) };
  }
};

export const getAnalyzedLinkedinContacts = async (linkedinProjectId: string) => {
  try {
    const response = await API_V1.get(`/linkedinproject/${linkedinProjectId}/getAnalyzedContacts`);

    return response.data;
  } catch (e) {
    Logger.trace('Error while fetching analyzed LinkedIn contacts!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e) };
  }
};

export const getLinkedinSearchResults = async (searchUrl: string, liAtCookie: string, sessionCookie: string, seatCookie?: string) => {
  try {
    const response = await API_V1.post('/linkedinproject/getLinkedinSearchResults', {
      searchUrl,
      liAtCookie,
      sessionCookie,
      seatCookie,
    });

    return response.data;
  } catch (e) {
    Logger.trace('Error while fetching Linkedin search results!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e) };
  }
};

export const getGroupProfile = async (projectIds: string[], lang: string) => {
  try {
    const response = await API_V1.post(
      '/linkedinproject/getGroupProfile',
      {
        projectIds,
      },
      {
        params: {
          lang,
        },
      }
    );

    return response.data;
  } catch (e) {
    Logger.trace('Error while getting group profile results!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e) };
  }
};
